import { makeStyles, Tooltip } from "@fluentui/react-components";
import { LocationFilled } from "@fluentui/react-icons";
import React from "react";

interface IDisplayAirportProps {
  airport: string;
  airportName: string;
}

const DisplayAirport: React.FC<IDisplayAirportProps> = ({
  airport = "",
  airportName = "",
}) => {
  const classes = useStyles();

  return (
    <div data-testid="airport-tooltip">
      <Tooltip
        key={airport}
        withArrow
        positioning="below"
        content={airportName}
        relationship="label"
      >
        <div className={`${classes.locationText}`}>
          <LocationFilled aria-label="Location Icon" />
          {airport}
        </div>
      </Tooltip>
    </div>
  );
};

export default DisplayAirport;

const useStyles = makeStyles({
  locationText: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
});
